// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__18mG3","dragIcon":"Choice_dragIcon__3tW58","left":"Choice_left__30nJV","input":"Choice_input__2Toy5"};